import { VyIcon } from '@vy/ui-design-system';
import { withDefault } from '@vy/utils';
import React from 'react';
import { VyTable } from '../../../../../components/new-design/table/vy-table/VyTable';
import type { VyTableMinimalProps } from '../../../../../components/new-design/table/vy-table/vy-table-types';
import { VyTableToolbar } from '../../../../../components/new-design/table/vy-table-toolbar/vy-table-toolbar';
import { useSearchWithSearchParams } from '../../../../../hooks/use-search-with-search-params';
import { ProductCreationStepperDialog } from '../CreateProductDialog/ProductCreationStepperDialog';
import { VyLoader } from '../../../../../components/new-design/feedback/Loader/VyLoader';
import { getProductsPageTableColumns } from './products-columns/products-columns';
import { type UnifiedProductRow } from './products-columns/products-columns-type';
import { Box } from '@mui/material';

type ProductsTableProps = Omit<VyTableMinimalProps<UnifiedProductRow>, 'tableName'> & {
  autoOpenCreateDialog?: boolean;
};

export const ProductsTable: React.FC<ProductsTableProps> = ({ autoOpenCreateDialog = false, ...props }) => {
  const [metersQuery, setCustomersSearch] = useSearchWithSearchParams();
  const [catalogProductsQuery, setCatalogProductsSearch] = useSearchWithSearchParams();

  const defaultMetersQuery = withDefault(metersQuery, '');
  const defaultCatalogProductsQuery = withDefault(catalogProductsQuery, '');
  const defaultSearchQuery = defaultMetersQuery.concat(defaultCatalogProductsQuery) ?? '';

  const columns = getProductsPageTableColumns();

  const handleOnSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCustomersSearch(event.target.value);
    setCatalogProductsSearch(event.target.value);
  };

  return (
    <>
      <VyTableToolbar>
        <VyTableToolbar.Queries>
          <VyTableToolbar.SearchInput
            onChange={handleOnSearch}
            defaultValue={defaultSearchQuery}
            placeholder="Search"
            label={undefined}
          />
        </VyTableToolbar.Queries>

        <VyTableToolbar.Actions>
          <ProductCreationStepperDialog autoOpen={autoOpenCreateDialog}>
            <VyTableToolbar.CtaButton sx={{ columnGap: '12px' }}>
              <VyIcon icon="PlusMedium" />
              Create New
            </VyTableToolbar.CtaButton>
          </ProductCreationStepperDialog>
        </VyTableToolbar.Actions>
      </VyTableToolbar>
      {props.loadingItems ? (
        <VyLoader
          height="100%"
          width="100%"
          sx={{
            padding: '16px',
          }}
        />
      ) : (
        <Box sx={{
          minHeight: 0
        }}>
          <VyTable
            tableName="products"
            columns={columns}
            {...props}
            sx={{
              ...props.sx,
            }}
            getRowId={(row) => `${row.type}-${row.id}`}
          />
        </Box>
      )}
    </>
  );
};
